function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="25" height="21" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M.311 11.215l9.742 9.514a1 1 0 0 0 1.397 0l1.362-1.33a1 1 0 0 0 0-1.43l-5.784-5.65H24a1 1 0 0 0 1-1V9.461a1 1 0 0 0-1-1H7.252l5.56-5.43a1 1 0 0 0 0-1.43L11.45.271a1 1 0 0 0-1.397 0L.31 9.785a1 1 0 0 0 0 1.43z" fill="#4A4A4A" /></svg>;
});